import { ComponentType } from 'react';
import styled from 'styled-components';
import { text2 } from '@ardoq/typography';
import { PlaceholderProps } from 'react-select';
import { SelectOption } from '../../types';
import { ellipsisCSS } from '@ardoq/style-helpers';
import { s8 } from '@ardoq/design-tokens';

const PlaceholderStyle = styled.span<{ $hasLeftIcon?: boolean }>`
  ${text2};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  ${ellipsisCSS};
  padding-left: ${({ $hasLeftIcon }) => ($hasLeftIcon ? s8 : 0)};
`;

export const PLACEHOLDER_SELECTOR = PlaceholderStyle.toString();

export const Placeholder: ComponentType<
  PlaceholderProps<SelectOption<unknown>>
> = ({ selectProps }) => (
  // @ts-expect-error todo
  <PlaceholderStyle $hasLeftIcon={Boolean(selectProps.iconName)}>
    {selectProps.placeholder}
  </PlaceholderStyle>
);
